import { createSelector } from 'reselect';

const authUser = auth => auth.employee?.user;

export default createSelector(state => state.auth, authUser);
